export default __webpack_public_path__ + "static/media/givepower-Lockup-H-blk.bb9ea092.svg";